const generatePagination = (currentPage, lastPage) => {
  const pages = [];
  let negativeAccumulator = 0;
  if (currentPage - 2 >= 1) {
    pages.push(currentPage - 2);
    negativeAccumulator--;
  }

  if (currentPage - 1 >= 1) {
    pages.push(currentPage - 1);
    negativeAccumulator--;
  }

  pages.push(currentPage);

  let comulator = 1;
  for (
    let initial = pages.length;
    pages.length < 5 && currentPage + comulator <= lastPage;
    initial++ && comulator++
  ) {
    pages.push(currentPage + comulator);
  }

  if (pages.length < 5) {
    negativeAccumulator--;
    for (
      let initial = pages.length;
      pages.length < 5 && currentPage + negativeAccumulator > 0;
      initial++ && negativeAccumulator--
    ) {
      pages.unshift(currentPage + negativeAccumulator);
    }
  }

  return pages;
};

export default generatePagination;
